import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { computeSmsSegments } from '#/shared/lib/sms-segments'
import { cn } from '#/shared/lib/utils'

/** Highlight the segment count once a message spans this many segments, to flag
 *  the rising per-segment cost of a long message. */
const SEGMENT_WARN_AT = 4

/** Live SMS character + segment count (Twilio rules), shown once there's text.
 *  `text` is the plain-text body that will actually be sent. */
export function SmsSegmentCounter({
  text,
  className,
}: {
  text: string
  className?: string
}) {
  const { t } = useTranslation()
  const info = useMemo(() => computeSmsSegments(text), [text])
  if (info.charCount === 0) return null
  return (
    <span
      className={cn(
        'shrink-0 tabular-nums',
        info.segments >= SEGMENT_WARN_AT ? 'text-orange-500' : 'text-warm-500',
        className,
      )}
    >
      {t('smsSegmentCounter.segmentInfo', {
        chars: info.charCount,
        count: info.segments,
      })}
    </span>
  )
}
